// import { useState, useEffect } from "react";
// import {
//   getRooms,
//   deleteRoom
// } from "../services/roomService";

// export default function ManageRooms() {
//   const [rooms, setRooms] = useState([]);

//   useEffect(() => {
//     setRooms(getRooms());
//   }, []);

//   const removeRoom = (id) => {
//     const updatedList = deleteRoom(id);
//     setRooms([...updatedList]);
//   };

//   return (
//     <div className="p-6">
//       <h1 className="text-2xl font-bold mb-4">Manage Rooms</h1>

//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//         {rooms.map((room) => (
//           <div key={room.id} className="border p-4 rounded shadow">
//             <img src={room.img} className="rounded mb-2" />
//             <h2 className="text-xl font-semibold">{room.name}</h2>
//             <p>Type: {room.type}</p>
//             <p>Price: ₹{room.price}</p>
//             <p>{room.desc}</p>

//             <div className="flex gap-3 mt-4">
//               <button className="bg-blue-500 px-3 py-1 text-white rounded">
//                 Edit
//               </button>

//               <button
//                 className="bg-red-600 px-3 py-1 text-white rounded"
//                 onClick={() => removeRoom(room.id)}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }



// import { useEffect, useState } from "react";
// import { getRooms, deleteRoom } from "../services/roomService";
// import RoomCard from "../components/RoomCard";
// import { useNavigate } from "react-router-dom";

// export default function ManageRooms() {
//   const navigate = useNavigate();
//   const [rooms, setRooms] = useState([]);

//   useEffect(() => {
//     setRooms(getRooms());
//   }, []);

//   const handleDelete = (id) => {
//     deleteRoom(id);
//     setRooms(getRooms());
//   };

//   return (
//     <div className="p-6">
//       <h1 className="text-3xl font-bold mb-4">Manage Rooms</h1>

//       <button
//         className="bg-green-600 text-white p-3 rounded mb-5"
//         onClick={() => navigate("/add-room")}
//       >
//         Add Room
//       </button>

//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//         {rooms.map((room) => (
//           <RoomCard
//             key={room.id}
//             room={room}
//             onDelete={handleDelete}
//             onEdit={(id) => navigate(`/edit-room/${id}`)}
//           />
//         ))}
//       </div>
//     </div>
//   );
// }

// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";
//  import RoomCard from "../components/RoomCard";

// export default function ManageRooms() {
//   const [rooms, setRooms] = useState([]);

//   useEffect(() => {
//     axios
//       .get("http://localhost:8080/api/rooms")
//       .then((res) => setRooms(res.data))
//       .catch((err) => console.error("Error loading rooms:", err));
//   }, []);

//   const deleteRoom = async (id) => {
//     if (!window.confirm("Delete this room?")) return;

//     try {
//       await axios.delete(`http://localhost:8080/api/rooms/${id}`);
//       setRooms((prev) => prev.filter((r) => r.id !== id));
//     } catch (e) {
//       console.error("Delete failed:", e);
//       alert("Delete failed!");
//     }
//   };

//   return (
//     <div className="container mt-4">
//       <h2 className="mb-3">Manage Rooms</h2>

//       <Link to="/add-room" className="btn btn-success mb-3">
//         ➕ Add New Room
//       </Link>

//       {rooms.length === 0 ? (
//         <div className="alert alert-warning">No rooms found.</div>
//       ) : (
//         <div className="row">
//           {rooms.map((room) => (
//             <div className="col-md-4 mb-4" key={room.id}>
//               <div className="card shadow-sm">
                
//                 <img
//                   src={
//                     room.image.startsWith("data:")
//                       ? room.image  
//                       : `http://localhost:8080/${room.image}`
//                   }
//                   alt={room.roomType}
//                   className="card-img-top"
//                   style={{ height: "200px", objectFit: "cover" }}
//                 />

//                 <div className="card-body">
//                   <h5 className="card-title">{room.roomType}</h5>

//                   <p className="card-text">
//                     <strong>Room No:</strong> {room.roomNumber}<br />
//                     <strong>Capacity:</strong> {room.capacity}<br />
//                     <strong>Price:</strong> ₹{room.price}
//                   </p>

//                   <div className="d-flex justify-content-between">
//                     <Link
//                       to={`/edit-room/${room.id}`}
//                       className="btn btn-primary btn-sm"
//                     >
//                       ✏ Edit
//                     </Link>

//                     <button
//                       className="btn btn-danger btn-sm"
//                       onClick={() => deleteRoom(room.id)}
//                     >
//                       🗑 Delete
//                     </button>
//                   </div>
//                 </div>

//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }


import { useEffect, useState } from "react";
import { getRooms, deleteRoom } from "../services/roomService";
import { Link } from "react-router-dom";

export default function ManageRooms() {
  const [rooms, setRooms] = useState([]);  // ALWAYS START WITH AN ARRAY

  const loadRooms = async () => {
    try {
      const res = await getRooms();

      // CASE 1: backend returns array []
      if (Array.isArray(res.data)) {
        setRooms(res.data);    
      }
      
          // CASE 2: backend returns { rooms: [] }
    else if (Array.isArray(res.data.rooms)) {
      setRooms(res.data.rooms);
    }
     
      else {
        console.error("API did not return an array:", res.data);
        setRooms([]);
      }
     


    } catch (err) {
      console.error("Error fetching rooms:", err);
      setRooms([]);   // Avoid crash
    }
  };

  useEffect(() => {
    loadRooms();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this room?")) return;
    await deleteRoom(id);
    loadRooms();
  };

  return (
    <div className="container mt-4">
      <h2>Manage Rooms</h2>

      <Link to="/admin/add-room" className="btn btn-success mb-3">
        + Add Room
      </Link>

      <div className="row">
           {rooms.map((room) => (
             <div className="col-md-4 mb-4" key={room.id}>
               <div className="card shadow-sm">
                
                 {/* <img
                   src={
                     room.image.startsWith("data:")   // room.image.startsWth("data:") before now added ? only
                       ? room.image  
                       : `http://localhost:8080/${room.image}`
                   } */}

                  <img
  src={
    room.image?.startsWith("data:")
      ? room.image // Base64 image
      : room.image?.startsWith("http")
      ? room.image // Full URL
      : `http://localhost:8080/${room.image.replace(/^\/+/, "")}` // public folder
  }
  
                   alt={room.roomType}
                   className="card-img-top"
                   style={{ height: "200px", objectFit: "cover" }}
                 />
                

              <div className="card-body">
                <h5 className="card-title">{room.roomType}</h5>
                <p>Room No: {room.roomNumber}</p>
                <p>Price: ₹{room.price}</p>

                <div className="d-flex justify-content-between">
                  <Link
                    to={`/admin/edit-room/${room.id}`}
                    className="btn btn-primary btn-sm"
                  >
                    Edit
                  </Link>

                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(room.id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}






